import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { from, unwrap, useOrg } from "@vixio/data";
import { formatDate } from "@vixio/ui";

/** Widget do Início: próximas sessões. */
export function NextSessionsWidget() {
  const org = useOrg();
  const q = useQuery({
    queryKey: ["programs", "widget", org.id],
    queryFn: () =>
      unwrap<Array<{ id: string; class_id: string; number: number; starts_at: string; topic: string | null; classes: { code: string; title: string } | null }>>(
        from("programs", "sessions").select("id, class_id, number, starts_at, topic, classes(code, title)").eq("org_id", org.id)
          .eq("status", "scheduled").gte("starts_at", new Date().toISOString()).order("starts_at").limit(5) as never,
      ),
  });
  if (!q.data?.length) return <p className="muted">Nenhuma sessão agendada. <Link to="/entrega/turmas">Abrir turmas</Link></p>;
  return (
    <ul className="vx-stack" style={{ gap: 8, margin: 0, padding: 0, listStyle: "none" }}>
      {q.data.map((s) => (
        <li key={s.id} className="vx-row" style={{ flexWrap: "nowrap", alignItems: "baseline" }}>
          <span className="num text-2" style={{ width: 92, flexShrink: 0 }}>{formatDate(s.starts_at)}</span>
          <span style={{ minWidth: 0 }}>
            <Link to={`/entrega/turmas/${s.class_id}`}>{s.classes?.title ?? "Turma"}</Link>
            <span className="text-2"> · sessão {s.number}{s.topic ? `: ${s.topic}` : ""}</span>
          </span>
        </li>
      ))}
    </ul>
  );
}
